export const environment = {
  credit_card_api_url: '',
  send_new_relic: false,
  paper_gateway_url: 'https://api.stag-v2.paper.id',
  paper_mars_api_url: 'https://mars.stag-v2.paper.id/api/v1',
};
